// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__VkXO9","loadingBox":"Loading_loadingBox__Ieo-O","pulse":"Loading_pulse__MoaAx"};